var map = {
	"./music-instructions.json": 5461,
	"./music-library-intro2024.json": 5462,
	"./music-library-launch2024.json": 5463,
	"./music-progression.json": 5464,
	"./startSourcesAdvanced.json": 5465,
	"./startSourcesSimple.json": 5466,
	"./startSourcesSimple2.json": 5467,
	"./startSourcesTracks.json": 5468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5028;